import { Injectable } from '@angular/core';
import { performance } from '@monsido/core/constants/general.constant';
import { default as PAGE_PERFORMANCE_LOCATIONS } from '../../constants/page-performance-locations.json';

@Injectable({
    providedIn: 'root',
})
export class PagePerformanceLocationService {
    getLocations () {
        return Object.keys(PAGE_PERFORMANCE_LOCATIONS)
            .filter((x) => performance.locations.indexOf(x) >= 0)
            .map((x) => ({
                city: PAGE_PERFORMANCE_LOCATIONS[x].city,
                country: PAGE_PERFORMANCE_LOCATIONS[x].country,
                country_code: PAGE_PERFORMANCE_LOCATIONS[x].country_code,
                key: x,
            }));
    }
}
